import React from "react";
import LandingModal from "../modals/LandingModal";
import ReCAPTCHA from "react-google-recaptcha";
import NormalSizeSignUpBtn from "../buttons/NormalSizeSignUpBtn";
import eduheroShieldText from '../../assets/images/shield+speech-ubble.svg';
import signupWords from '../../assets/images/sign-up-words.svg';
import { useState } from "react";
import PixelEdumanLoader from "../loading/PixelEdumanLoader";
import InputEmailComp from "../inputs/input/InputEmailComp";
import InputPasswordComp from "../inputs/input/InputPasswordComp";

import "../../assets/css/login/LoginCompCommon.css";
import "../../assets/css/login/SignUp.css";


const SignUp = ({controllerState, setControllerState, setLoginSelected, fetchMessage, setFetchMessage, verifyData}) => {
    const [loading, setLoading] = useState(false);
    const [contentForm, setContentForm] = useState({
        email: "",
        password: ""
    });
    
    const signUpOnClickHandler = (e) => {
        e.preventDefault();
        setFetchMessage(false);
        setLoading(true);

        const registerFormEl = document.getElementById('registerForm');
        const formData = new FormData(registerFormEl);
        const bodyObj = Object.fromEntries(formData.entries());
        

        fetch(`/routes/api/sessions/register/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: (JSON.stringify(contentForm))
        })
        .then(res => {
            if(res.ok) {
                return res.json();
            }

            throw new Error();
        })
        .then(data => {
            console.log(data);
            if(setFetchMessage) {
                setFetchMessage([(data?.message || "Something went wrong. Try again in a few moments."), (data?.type || "error")]);
            }

            if(data.type === "success") {
                if(setLoginSelected) {
                    setLoginSelected(true);
                }
    
                setControllerState(false);
            }

            setLoading(false);
        })
        .catch(err => {
            console.log(err);
            if(setFetchMessage && err?.message) {
                setFetchMessage([err.message, "error"]);
            }
            
            setLoading(false);
        });
    }

    const captchaOnChange = () => {
        console.log("recaptcha");
    }

    const signupUpdateFunction = (e, field, value) => {
        if(field) {
            setContentForm(prev => ({
                ...prev,
                [field]: value
            }));
        }
    }

    return (
        <>
            {   controllerState &&
                (
                    <LandingModal setFalseArr={[setControllerState]} alignLeft={true}>
                            <div className='modal--wrapper signupModal flex flexCenter'>
                                
                                <div className='modal--contentWrapper flex flexCenter flexColumn'>
                                    <div className='modal-header'>
                                        <div className='modal-header-scroller'>
                                            <div className="modal-header-wrapper textAlignCenter">
                                                <h2>Sign Up</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal--contentContainer flex flexColumn flexAlignCenter">
                                        <form id='registerForm' type="submit" className="flex flexColumn" onSubmit={signUpOnClickHandler}>
                                            {fetchMessage && <>
                                                <div className={"textAlignCenter " + ((fetchMessage[1] === "error") ? "landing-error" : "landing-success")}>
                                                    {fetchMessage[0]}
                                                </div>
                                            </>}
                                            <label htmlFor="email">Email:</label>
                                            {/* <input name="email" type="email" placeholder="eduhero@esc6.net" required /> */}
                                            <InputEmailComp className={"loginSignUpInput"} field={"email"} placeholder={"eduhero@email.net"} required={true} name={"email"} value={contentForm.email} updateFunction={signupUpdateFunction} form={"loginForm"} />

                                            <label htmlFor="password">Password: </label>
                                            {/* <input name="password" type="password" placeholder="Eduh3r01sGr8!" id='pass' required /> */}
                                            <InputPasswordComp className={"loginSignUpPass"} field={"password"} name={"password"} placeholder={"Eduh3r012@"} required={true} value={contentForm.password} updateFunction={signupUpdateFunction} form={"loginForm"} />

                                            {/* button needed for "enter" key submission while focused on input field */}
                                            <button type='submit' hidden></button>
                                        </form>
                                        
                                        <div className='login-container sign-container flex flexAlignCenter flexJustifySpaceBetween'>
                                            <div className='recaptcha'>
                                                <ReCAPTCHA sitekey="6LeqzuMhAAAAAF4bJ99T_e9M0xfOruETe2FaZhkE" size="normal" id='recaptchaNormal' onChange={captchaOnChange} />
                                                <ReCAPTCHA sitekey="6LeqzuMhAAAAAF4bJ99T_e9M0xfOruETe2FaZhkE" size="compact" id='recaptchaCompact' onChange={captchaOnChange} />
                                            </div>                            
                                            <div className="flex flexAlignCenter modal--contentContainer--buttons">
                                                <NormalSizeSignUpBtn onClickDo={signUpOnClickHandler} >
                                                    <img src={signupWords} alt='sign up'></img>
                                                </NormalSizeSignUpBtn>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='signupImgWrapper'>
                                    <img alt='Eduhero logo' src={eduheroShieldText} />
                                </div>
                                {   loading &&
                                    <>
                                        <PixelEdumanLoader isAbsolute={true} message={"Creating..."} />
                                    </>
                                }
                            </div>
                    </LandingModal>
                )
            }
        </>
    );
};

export default SignUp;